import { render } from "./CsrfToken.vue?vue&type=template&id=4c0c7fe4"
import script from "./CsrfToken.vue?vue&type=script&lang=js"
export * from "./CsrfToken.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/aryeo/aryeo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__